export default "__VITE_ASSET__D7zhuS9Y__"